import React from "react";
import ContactUs from "./Form";

function Modal({btnclass}) {
  const [showModal, setShowModal] = React.useState(false);
  return (
    <>
   
      <button
        className={btnclass} 
        type="button"
        onClick={() => setShowModal(true)}
      >
        <p className="text-white">
        Get Quote{" "}
        </p>
      </button>
   
      {showModal ? (
        <>
          <div className="justify-center  items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none">
            <div className="relative w-auto my-6 mx-auto max-w-3xl">
              {/*content*/}
              <div className="border-2 p-5 rounded-xl shadow-lg relative flex flex-col w-full bg-slate-200 outline-none focus:outline-none">
                {/*header*/}
                <div className="flex items-center text-center p-5 border-b  border-solid border-slate-300 rounded-t">
                  <h3 className="text-3xl  font-semibold">
                    Submit the form to get quote
                  </h3>
                  <button
                    className="p-1 ml-auto bg-transparent border-0 text-black opacity-5 float-right text-3xl leading-none font-semibold outline-none focus:outline-none"
                    onClick={() => setShowModal(false)}
                  >
                    <span className="bg-transparent text-black opacity-5 h-6 w-6 text-2xl block outline-none focus:outline-none">
                      ×
                    </span>
                  </button>
                </div>
                {/*body*/}
                <div className="relative p-1 flex-auto">
                  {<ContactUs setShowModal={setShowModal} />}
                </div>
                {/*footer*/}
                <div className="flex items-center justify-end p-6 border-t border-solid border-blue-200 rounded-lg">
                  <button
                    className="text-red-500 background-transparent font-bold uppercase px-6 py-2 text-sm outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
                    type="button"
                    onClick={() => setShowModal(false)}
                  >
                    Close
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
        </>
      ) : null}
    </>
  );
}
export default Modal;
